import { breakpoints, theme } from '../constants';
import type { ThemeOptions } from '@mui/material';

const extraVariants: any = {
  maxWidthNarrow: {
    [breakpoints.up('narrow')]: {
      maxWidth: breakpoints.values.narrow,
    },
  },
};

const Container: ThemeOptions['components'] = {
  MuiContainer: {
    styleOverrides: {
      root: {
        [breakpoints.down('md')]: {
          '&:not(.MuiContainer-disableGutters)': {
            paddingBottom: theme.spacing(2),
          },
        },
      },
      ...extraVariants,
    },
  },
};

export default Container;
